// extracted by mini-css-extract-plugin
export default {"PriceLabelContainer":"styles_PriceLabelContainer__EgO3a","PriceLabel":"styles_PriceLabel__KrR0t"};